import { render, staticRenderFns } from "./playtimeByUsersAreaChart.vue?vue&type=template&id=c2e5d59e&scoped=true"
import script from "./playtimeByUsersAreaChart.vue?vue&type=script&lang=js"
export * from "./playtimeByUsersAreaChart.vue?vue&type=script&lang=js"
import style0 from "./playtimeByUsersAreaChart.vue?vue&type=style&index=0&id=c2e5d59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e5d59e",
  null
  
)

export default component.exports